import WellnessWheel from "./index";

export default function WellnessWheelExamples() {
  return (
    <WellnessWheel
      score={75}
      vitals={{ enabled: true, categoryScore: 60 }}
      lifestyle={{ enabled: true, categoryScore: 15 }}
      health={{ enabled: true, categoryScore: 0 }}
      info={{ enabled: true, categoryScore: 20 }}
      mentalHealth={{ enabled: true, categoryScore: 10 }}
    />
  );
}
